export default {
  baseStyle: {
    color: 'green.700',
  },
};
